import { LabAffiliation } from '../data/models/lab-affiliation.model';
import { AssignmentStatusTypes } from './constants';
import { ActivityValidation } from '../data/models/activity-validation.model';

export interface State {
    labAffiliations: LabAffiliation[];

    derivedLabAffiliation: LabAffiliation;

    showConfirmation: boolean;
    showHelp: boolean;

    contextualHelpHTML: string;

    assignmentStatus: AssignmentStatusTypes;
    activityValidation: ActivityValidation;
    activityRedirectUrl: string;

    error: any;
}

export const initialState: State = {
    labAffiliations: null,

    derivedLabAffiliation: null,

    showConfirmation: false,
    showHelp: false,

    contextualHelpHTML: null,

    assignmentStatus: AssignmentStatusTypes.INIT,
    activityValidation: null,
    activityRedirectUrl: null,

    error: null,
};
